export { TutorTrainingQuestion, type TutorTrainingQuestionProps } from "./TutorTrainingQuestion"
